import { authorizedRequest } from 'videoReview/api'
import { Cue } from 'videoReview/utils/parseVtt'

export type SaveSubtitlesProps = {
  id: string
  lang: string
  cues: Cue[]
}

export type SaveSubtitlesResults = {
  success: boolean
  id?: string
  lang?: string
  error?: string
}

export const saveSubtitles = async ({
  id,
  lang,
  cues,
}: SaveSubtitlesProps): Promise<SaveSubtitlesResults> => {
  const response = await authorizedRequest({
    endpoint: `v1/media/${id}/subtitle/save`,
    method: 'POST',
    body: { lang, cues },
  })
  return (await response.json()) as SaveSubtitlesResults
}
